import { render, staticRenderFns } from "./DriverPayments.vue?vue&type=template&id=aa2d038e&"
import script from "./DriverPayments.vue?vue&type=script&lang=ts&"
export * from "./DriverPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports